module.exports = __webpack_public_path__ + "static/media/fintech-img.91b00192.png";